__turbopack_context__.v({
  "label": "label-module-scss-module__1_mEuW__label",
});
